import { SelectC } from 'components'

const crossSaleOptions = [
  { id: 'YES', label: 'Sim' },
  { id: 'NO', label: 'Não' }
]

export const SelectCrossSale = () => {
  return (
    <SelectC
      name="crossSale"
      label="Venda Cruzada"
      options={crossSaleOptions}
      getOptionLabel={(option: any) => option?.label || ''}
    />
  )
}
